import TIME_CONFIG from '../../config/timeConfig';

let offset = 0;
let syncPromise = null;

export const syncTimeWithServer = async () => {
  if (syncPromise) return syncPromise;

  syncPromise = (async () => {
    try {
      const startTime = Date.now();
      let response;
      const url = `${window.location.origin}/index.html?_cb=${startTime}`;

      try {
        response = await fetch(url, {
          method: 'HEAD',
          cache: 'no-cache',
        });
        if (!response.ok) throw new Error('HEAD failed');
      } catch (e) {
        response = await fetch(url, {
          method: 'GET',
          cache: 'no-cache',
        });
      }

      const endTime = Date.now();
      const serverDateStr = response.headers.get('date') || response.headers.get('Date');
      if (serverDateStr) {
        const serverTime = new Date(serverDateStr).getTime();
        const latency = (endTime - startTime) / 2;
        const adjustedServerTime = serverTime + latency;
        offset = adjustedServerTime - endTime;
        console.log(`[TimeSync] Time synchronized. Offset: ${offset}ms, Latency: ${latency}ms`);
      }
    } catch (error) {
      console.error('[TimeSync] Same-origin time synchronization failed:', error);
    } finally {
      syncPromise = null;
    }
  })();

  return syncPromise;
};

export const updateOffsetFromResponseHeaders = (headers) => {
  if (!headers) return;
  try {
    const serverDateStr = headers.get('date') || headers.get('Date');
    if (serverDateStr) {
      const serverTime = new Date(serverDateStr).getTime();
      const clientTime = Date.now();
      offset = serverTime - clientTime;
      console.log(`[TimeSync] Offset updated from API response: ${offset}ms`);
    }
  } catch (e) {
    console.error('[TimeSync] Failed to parse Date header:', e);
  }
};

export const getSynchronizedTime = () => {
  return Date.now() + offset;
};

export const getSynchronizedDate = () => {
  return new Date(getSynchronizedTime());
};

export const isNotSriLankanTimezone = () => {
  const localOffset = new Date().getTimezoneOffset();
  return localOffset !== TIME_CONFIG.SRI_LANKA_OFFSET_MINUTES;
};

export const parseSriLankanDateTime = (dateStr, timeStr) => {
  if (!dateStr) return null;
  try {
    let formattedDate = dateStr;
    if (timeStr) {
      formattedDate = dateStr.includes('T') ? dateStr : `${dateStr}T${timeStr}`;
      if (timeStr.split(':').length === 2) {
        formattedDate += ':00';
      }
    } else if (!dateStr.includes('T') && dateStr.includes(' ')) {
      formattedDate = dateStr.replace(' ', 'T');
    }
    const hasTimezone = /([Z+-]\d{2}:?\d{2})$/.test(formattedDate) || formattedDate.endsWith('Z');
    const finalDateStr = hasTimezone ? formattedDate : `${formattedDate}${TIME_CONFIG.SRI_LANKA_OFFSET_STRING}`;
    const parsed = new Date(finalDateStr);
    if (isNaN(parsed.getTime())) return null;
    return parsed;
  } catch (e) {
    return null;
  }
};

export const toSriLankanDate = (dateOrTimestamp) => {
  const d = new Date(dateOrTimestamp);
  return new Date(d.toLocaleString('en-US', { timeZone: TIME_CONFIG.SRI_LANKA_TIMEZONE }));
};

export const formatSriLankanDate = (dateOrTimestamp, options = {}) => {
  return new Date(dateOrTimestamp).toLocaleDateString('en-US', {
    timeZone: TIME_CONFIG.SRI_LANKA_TIMEZONE,
    ...options
  });
};

if (typeof window !== 'undefined') {
  syncTimeWithServer();
  setInterval(syncTimeWithServer, TIME_CONFIG.SYNC_INTERVAL_MS);
}

const timeSyncService = {
  syncTimeWithServer,
  updateOffsetFromResponseHeaders,
  getSynchronizedTime,
  getSynchronizedDate,
  isNotSriLankanTimezone,
  parseSriLankanDateTime,
  toSriLankanDate,
  formatSriLankanDate
};

export default timeSyncService;
